import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventData } from 'ui-components/common';
import { WebMenuNode } from '../../../../com/ibm/tw/commons/beans/web.menu.node';
import { B2cLoginComponent } from '../../../../com/ibm/tw/commons/mvc/b2c.login.component';
import { AxthenticationService } from '../../../../services';
import { CcmotviewService } from './../ccmotview.service';
import { CcmotviewHomeViewForm } from './ccmotview.home.viewform';


/**
 * 	服務總覽 Home Component
 *
 * @author Benny
 * @version 1.0, 2017/09/11
 * @see
 * @since
 */
@Component({
    standalone: false,
    templateUrl: 'ccmotview.home.component.html',
    selector: 'gib-ccmotview-popup'
})
export class CcmotviewHomeComponent extends B2cLoginComponent<CcmotviewHomeViewForm> {

    /** popup display */
    @Input() display: boolean = false;

    // parent return function
    @Output() callBack = new EventEmitter();

    @Output() onClick: EventEmitter<any> = new EventEmitter();

    /** 建構子 */
    constructor(protected ccmotviewService: CcmotviewService, protected axthenticationService: AxthenticationService) {
        super(ccmotviewService);
    }

    protected initViewForm(): void {
        // console.log('init Ccmotview Popup')
        this.viewForm = new CcmotviewHomeViewForm();
        this.viewForm.basePath = 'pagecode.cot.ccmotview';
        this.viewForm.navigatePage = 'ccmotviewhome';
        this.viewForm.headerTitle = this.txnService.transform('服務總覽', 'chm00001759', null);
    }

    onHide() {
        this.callBack.emit();
    }

    onShow() {
        // console.log('show......');

        // 成功回呼方法
        let succCall = (viewForm: CcmotviewHomeViewForm) => {
            this.viewForm = viewForm;
            this.doChangeWebMenuNode(null);
            this.unMaskPage();
        }
        // 失敗回呼方法
        let errorCall = (viewForm: CcmotviewHomeViewForm) => {
            // console.log('errorCall...');
            //  this.unMaskPage();
            this.viewForm = viewForm;
            this.unMaskPage();
            //  this.showPageError(viewForm.gwPageValidator);
        }
        this.doPostAction(this.viewForm, new CcmotviewHomeViewForm(), succCall, errorCall, 'doQueryAction');
    }


    /**
     * 選單的變更
     */
    doChangeWebMenuNode(event: EventData): void {
        // console.log('selectArea...' + this.viewForm.selectArea);
        for (let menu of this.viewForm.webMenuNodeList) {
            if (menu.menuIxd === this.viewForm.selectArea) {
                this.viewForm.currentMenuNode = menu;
                break;
            }
        }
    }


    /**
     * 點擊menu
     * @param event
     * @param clickmenu
     */
    toggleSubMainMenu(event: Event, clickmenu: WebMenuNode): void {
        event.preventDefault();
        if (!clickmenu.permission) {
            return;
        }

        let eventData: EventData = new EventData(event, clickmenu.url, true, null);
        eventData.taskID = clickmenu.taskIxd;

        clickmenu.areaType = this.viewForm.selectArea;
        eventData.originalEvent = clickmenu;
        console.log('click...' + clickmenu.url + ':' + this.viewForm.selectArea);

        // 進行click動作
        this.onClick.emit(eventData);
    }
}
